import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { loadPeriodos } from '../../store/actions/Periodos';

import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Chip from '@material-ui/core/Chip';
import Tooltip from '@material-ui/core/Tooltip';
import Zoom from '@material-ui/core/Zoom';
import ScannerOutlinedIcon from '@material-ui/icons/ScannerOutlined';
import CropOutlinedIcon from '@material-ui/icons/CropOutlined';
import ImageSearchOutlinedIcon from '@material-ui/icons/ImageSearchOutlined';
import KeyboardOutlinedIcon from '@material-ui/icons/KeyboardOutlined';
import RateReviewOutlinedIcon from '@material-ui/icons/RateReviewOutlined';
import PersonAddOutlinedIcon from '@material-ui/icons/PersonAddOutlined';
import GetAppIcon from '@material-ui/icons/GetAppOutlined';
import CloudUploadOutlinedIcon from '@material-ui/icons/CloudUploadOutlined';
import SwapHorizOutlinedIcon from '@material-ui/icons/SwapHorizOutlined';

import { makeStyles } from '@material-ui/core/styles';
import { red, green, amber, blue, grey } from '@material-ui/core/colors';

import ProvaService from '../../services/Prova';
import EnumService from '../../services/Enum';
import { errors } from '../../services/API';

import { download } from '../../helper/FileHelper';

import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import Title from '../../components/Title/Title';
import Table from '../../components/Table/Table';
import Toast from '../../components/Toast/Toast';
import { ButtonPrimary } from '../../components/Button/Button';
import DialogMarcacoes from '../../components/Digitacao/DialogMarcacoes';
import DialogVincularCandidato from '../../components/Prova/DialogVincularCandidato';
import DialogSubstituirCartao from '../../components/Prova/DialogSubstituirCartao';
import DialogTrocarCandidatos from '../../components/Prova/DialogTrocarCandidatos';
import DownloadApps from '../../components/DownloadApps/DownloadApps';
import { MODOS_SESSAO } from '../../components/Digitacao/PainelSessaoDigitacao';
import {
    verifyPagingAndSorting,
    PAGE,
    SIZE,
    ASC,
    TOTAL_ELEMENTS,
    TOTAL_PAGES,
} from '../../components/Table/Utils';

import { patternEnum } from '../../variables/Enums/Enum';

import ProvaFilter from '../../forms/Prova/ProvaFilter';
import ButtonAdd from '../../forms/Buttons/ButtonsAdd';

import { verifyPersistence, removePagingAndSorting } from '../../helper/PaginationHelper';

import { isAdministradorOuCentral, isCoordenadorOuApoioSecretarial } from '../../security/AuthorizedFunction';

import { Layout } from '../../layouts/private/Private';
import { cpfMask } from '../../helper/MaskHelper';

const STATUS_DIGITACAO = ['ENVIADA_DIGITACAO', 'NA_FILA_DIGITACAO'];
const STATUS_REVISAO = ['ENVIADA_REVISAO', 'NA_FILA_REVISAO'];

export const useStyles = makeStyles(theme => ({
    body: {
        margin: theme.spacing(3, 0),
    },
}));

const Evento = ({ nome, icone, executado = false, textoPosExecucao = "" }) => {
    const semEvento = `Sem ${nome} Registrada`;

    return (
        <Tooltip title={executado ? `${textoPosExecucao}` : semEvento} TransitionComponent={Zoom}>
            {icone}
        </Tooltip>
    )
}

export class Prova extends Component {
    constructor(props) {
        super(props);
        this.state = {
            page: PAGE,
            size: SIZE,
            totalElements: TOTAL_ELEMENTS,
            totalPages: TOTAL_PAGES,
            sort: [{ orderBy: 'dataRecebimento', order: ASC }],
            defaultOrderBy: 'dataRecebimento',
            filtered: false,
            filters: [],
            jaFezBuscaDaUrl: false,
            provas: [],
            loading: true,
            optionsStatusProva: [],
            dialogMarcacoes: { open: false, idProva: null, modo: MODOS_SESSAO.DIGITAR },
            dialogVincularCandidato: { open: false, idProva: null },
            dialogSubstituirCartao: { open: false, idProva: null },
            dialogTrocarCandidatos: { open: false, idProva: null },
        }

        this.state = verifyPersistence(this.state, this.props.location);
    }

    setToast = t => this.Toast = t;
    setProvaFilter = f => this.ProvaFilter = f;

    labelSemPermissao = "Você não tem permissão para fazer isso";

    labelVerCorteMarcacoes = id => isAdministradorOuCentral() ? "Ver Corte de Marcações" : this.labelSemPermissao;
    labelDownloadCartao = id => isAdministradorOuCentral() || isCoordenadorOuApoioSecretarial() ? "Baixar Cartão" : this.labelSemPermissao;
    labelDigitarMarcacoes = id => isAdministradorOuCentral() || isCoordenadorOuApoioSecretarial() ? "Digitar Marcações" : this.labelSemPermissao;
    labelRevisarMarcacoes = id => isAdministradorOuCentral() ? "Revisar Marcações" : this.labelSemPermissao;
    labelVincularCandidato = id => isAdministradorOuCentral() ? "Vincular Candidato" : this.labelSemPermissao;
    labelSubstituirCartao = id => isAdministradorOuCentral() ? "Substituir Cartão" : this.labelSemPermissao;
    labelTrocarCandidatos = id => isAdministradorOuCentral() ? "Trocar Candidatos" : this.labelSemPermissao;

    emStatusDe = (id, statuses) => {
        const prova = this.state.provas.find(c => c.id === id);

        return Boolean(prova) && statuses.includes(prova.status);
    }

    podeDigitar = id => {
        const prova = this.state.provas.find(c => c.id === id);

        return this.emStatusDe(id, STATUS_DIGITACAO) || (Boolean(prova) && Boolean(prova.presaNaLeitura));
    }

    handleVerCorte = (id, corte) => {
        const prova = this.state.provas.find(d => d.id === id);
        window.open(`${process.env.REACT_APP_CDN_URL}/${prova.codigo}/${prova.cartao}/${corte}.jpg`, "", `width=1024, height=512, menubar=no, toolbar=no, location=no, status=no`)
    };

    handleDownloadCartao = id => {
        const prova = this.state.provas.find(d => d.id === id);

        this.Toast.setState({
            message: {
                message: "Em instantes o download iniciará automaticamente",
                type: "info",
                open: true
            }
        });

        ProvaService.downloadCartao(prova.id)
            .then(res => download(res))
            .catch(error => {
                const e = errors(error);
                this.Toast.setState({
                    message: {
                        message: e.message,
                        type: e.type,
                        open: true
                    }
                });
            });
    }

    abrirDialogMarcacoes = (id, modo) => {
        ProvaService.podeDigitarAlternativamente(id)
            .then(res => {
                if (res.data && res.data.podeDigitar) {
                    this.setState({ ...this.state, dialogMarcacoes: { open: true, idProva: id, modo } });
                    return;
                }

                this.Toast.setState({
                    message: {
                        message: (res.data && res.data.motivoBloqueio) || `Esta prova não pode ser ${modo === MODOS_SESSAO.REVISAR ? 'revisada' : 'digitada'} neste momento.`,
                        type: "warning",
                        open: true
                    }
                });
            })
            .catch(error => {
                const e = errors(error) || { message: "Não foi possível verificar a disponibilidade da prova.", type: "error" };
                this.Toast.setState({
                    message: {
                        message: e.message,
                        type: e.type,
                        open: true
                    }
                });
            });
    }

    handleDigitarMarcacoes = id => this.abrirDialogMarcacoes(id, MODOS_SESSAO.DIGITAR);

    handleRevisarMarcacoes = id => this.abrirDialogMarcacoes(id, MODOS_SESSAO.REVISAR);

    handleCloseDialogMarcacoes = () => this.setState({ ...this.state, dialogMarcacoes: { open: false, idProva: null, modo: MODOS_SESSAO.DIGITAR } });

    handleMarcacoesRegistradas = dto => {
        const revisao = this.state.dialogMarcacoes.modo === MODOS_SESSAO.REVISAR;
        const partes = [];

        if (dto) {
            if (dto.notaCalculadaNova !== null && dto.notaCalculadaNova !== undefined)
                partes.push(`Nota: ${dto.notaCalculadaNova}`);

            if (dto.statusFinal)
                partes.push(`Status: ${patternEnum(dto.statusFinal, this.state.optionsStatusProva)}`);

            if (dto.divergenciaNota)
                partes.push("Divergência — enviada para revisão");
        }

        this.Toast.setState({
            message: {
                message: partes.length ? partes.join(" | ") : (revisao ? "Revisão registrada com sucesso." : "Digitação registrada com sucesso."),
                type: dto && dto.divergenciaNota ? "warning" : "success",
                open: true
            }
        });

        this.setState({ ...this.state, dialogMarcacoes: { open: false, idProva: null, modo: MODOS_SESSAO.DIGITAR } }, () => this.loadData());
    }

    provaSemVinculo = id => {
        const prova = this.state.provas.find(c => c.id === id);

        return Boolean(prova) && !prova.candidato;
    }

    handleVincularCandidato = id => this.setState({ ...this.state, dialogVincularCandidato: { open: true, idProva: id } });

    handleCloseDialogVincularCandidato = () => this.setState({ ...this.state, dialogVincularCandidato: { open: false, idProva: null } });

    handleCandidatoVinculado = (dto, candidato) => {
        this.Toast.setState({
            message: {
                message: `Candidato ${candidato ? candidato.nomeExibicao : ''} vinculado com sucesso.`,
                type: "success",
                open: true
            }
        });

        this.setState({ ...this.state, dialogVincularCandidato: { open: false, idProva: null } }, () => this.loadData());
    }

    podeSubstituirCartao = id => {
        if (!isAdministradorOuCentral()) return false;

        const prova = this.state.provas.find(c => c.id === id);

        return Boolean(prova) && prova.possoSubstituirCartao;
    }

    handleSubstituirCartao = id => this.setState({ ...this.state, dialogSubstituirCartao: { open: true, idProva: id } });

    handleCloseDialogSubstituirCartao = () => this.setState({ ...this.state, dialogSubstituirCartao: { open: false, idProva: null } });

    handleCartaoSubstituido = () => {
        this.Toast.setState({
            message: {
                message: "Cartão substituído com sucesso. A prova está sendo reprocessada.",
                type: "success",
                open: true
            }
        });

        this.setState({ ...this.state, dialogSubstituirCartao: { open: false, idProva: null } }, () => this.loadData());
    }

    handleTrocarCandidatos = id => this.setState({ ...this.state, dialogTrocarCandidatos: { open: true, idProva: id } });

    handleTrocarCandidatosSemSelecao = () => this.setState({ ...this.state, dialogTrocarCandidatos: { open: true, idProva: null } });

    handleCloseDialogTrocarCandidatos = () => this.setState({ ...this.state, dialogTrocarCandidatos: { open: false, idProva: null } });

    handleCandidatosTrocados = () => {
        this.Toast.setState({
            message: {
                message: "Candidatos trocados com sucesso.",
                type: "success",
                open: true
            }
        });

        this.setState({ ...this.state, dialogTrocarCandidatos: { open: false, idProva: null } }, () => this.loadData());
    }

    loadData = async () => {
        this.props.loadPeriodos();

        const statusProva = await EnumService.listarStatusProva().then(res => res.data);
        this.setState({ ...this.state, optionsStatusProva: [...statusProva] });

        let filters = verifyPagingAndSorting(this.state);

        if (!this.state.jaFezBuscaDaUrl) {
            const parseFilters = queryString.parse(this.props.location.search);
            const urlFilters = [
                'status', 'semFinalizacao', 'digitalizada', 'cortada', 'digitada', 'comProblemasNoCorte',
                'leituraMarcacoesRealizada', 'comProblemasNaLeituraMarcacoes',
                'comLeituraMarcacoesSemNotaCalculada', 'comReservaDigitacaoPresa',
                'comDivergenciaNaoRevisada', 'comCandidatoVinculado', 'comProblemas', 'buscarRegiaoGrupo',
            ];

            urlFilters.forEach(field => {
                if (parseFilters[field] !== undefined)
                    filters.push({ field, value: parseFilters[field] });
            });

            this.setState({ jaFezBuscaDaUrl: true });
        }

        this.setState({
            filters: [...filters],
            filtered: true,
            loading: true
        });

        await ProvaService.filters(filters)
            .then(res => {
               if (res.data.content) {
                    this.setState({
                        ...this.state,
                        provas: [...res.data.content],
                        page: res.data.number,
                        size: res.data.size,
                        totalElements: res.data.totalElements,
                        totalPages: res.data.totalPages,
                        loading: false,
                    });

                    this.ProvaFilter.handleFilterPersistence(filters);
                } else {
                    this.setState({
                        ...this.state,
                        provas: [],
                        page: PAGE,
                        size: SIZE,
                        totalElements: TOTAL_ELEMENTS,
                        totalPages: TOTAL_PAGES,
                        loading: false,
                    });
                }
            })
            .catch(error => {
                const e = errors(error);
                this.Toast.setState({
                    message: {
                        message: e.message,
                        type: e.type,
                        open: true
                    }
                })

                this.setState({ loading: false });
            })
    }

    filterData = (filters, isActive = true) => this.setState({ filtered: isActive, filters: [...removePagingAndSorting(filters)] }, () => this.loadData());
    handlePage = page => this.setState({ page: page }, () => this.filterData(this.state.filters));
    handleRowsPerPage = (size, page) => this.setState({ size: size, page: page }, () => this.filterData(this.state.filters));
    handleSort = (orderBy, order) => {
        if (this.state.sort.find(s => s.orderBy === orderBy)) {
            let newSort = this.state.sort.filter(s => s.orderBy !== orderBy);
            newSort.splice(this.state.sort.indexOf(this.state.sort.find(s => s.orderBy === orderBy)), 0, { orderBy: orderBy, order: order })
            this.setState({ ...this.state, sort: [...newSort], filtered: true });
        } else {
            this.setState({ ...this.state, sort: [...this.state.sort.filter(s => s.orderBy !== orderBy), { orderBy: orderBy, order: order }], filtered: true });
        }
    }
    handleClearSort = (orderBy) => {
        this.setState({ ...this.state, filtered: true, sort: orderBy ? [...this.state.sort.filter(s => s.orderBy !== orderBy)] : [{ orderBy: this.state.defaultOrderBy, order: ASC }] });
    };
    handleTotalPages = () => this.state.totalPages;
    handleTotalElements = () => this.state.totalElements;
    handleFilterPersistence = () => this.ProvaFilter ? this.ProvaFilter.state ? this.ProvaFilter.handleFilterPersistence(this.state.filters) : null : null;

    componentDidMount() { this.loadData(); }

    carregarNome = (candidato) => {
        if (!candidato)
            return 'Sem Vínculo Registrado';
        
        return (
            <>
                {candidato.nomeExibicao}                
                {candidato.status !== "FINALIZADO" && 
                    <Chip size="small" label={candidato.status}  style={{ backgroundColor: "#c00000", fontWeight: '800', color: "white", marginLeft: '3px'}} />
                }
            </>
        )
    }

    dotNota = (color) => <span style={{ margin: 2, padding: 5, borderRadius: 20, backgroundColor: color, color: "white", display: 'inline-block', fontSize: 10 }}><center> </center></span>;

    carregarNotas = (id) => {
        const prova = this.state.provas.find(c => c.id === id);
        
        const patternNota = (nota, title, color) => 
            <Tooltip title={nota ? title : `Sem ${title}`} TransitionComponent={Zoom}>
                <Chip size="small" label={nota ?? '-'}  style={{ backgroundColor: `${color}`, fontWeight: '600', color: "white", marginRight: '2px'}} />
            </Tooltip>

        return <>
            {patternNota(prova.notaCalculada, `Nota de Leitura de Marcações`, "#01378f")} 
            {patternNota(prova.notaDigitada, `Nota de Digitação de Marcações`, "#d05d0b")} 
            {patternNota(prova.notaRevisada, `Nota de Revisão`, "#026a12")}
            {patternNota(prova.notaPosRecurso, `Nota de Recurso`, "#870496")}
        </>
    }

    carregarRegioes = (id) => {
        const prova = this.state.provas.find(c => c.id === id);
        return `${prova.regiao} ${prova.regiaoGrupo ? ` / ${prova.regiaoGrupo}` : ''}`;
    }

    carregarCodigo = (value, id) => {
        const prova = this.state.provas.find(c => c.id === id);
        const descartada = Boolean(prova) && prova.status === 'DESCARTADA';

        if (!descartada) return value;

        return (
            <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                <span>{value}</span>
                <Tooltip title="Prova descartada — não retorna a nenhum fluxo" TransitionComponent={Zoom}>
                    <Chip size="small" label="Descartada" style={{ backgroundColor: red[600], fontWeight: '600', color: "white", marginLeft: '3px' }} />
                </Tooltip>
            </div>
        );
    }

    formatarColunaStatus = (id) => {
        const prova = this.state.provas.find(c => c.id === id);

        return <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
            { isAdministradorOuCentral() &&
                <>
                    <Evento 
                        executado={prova.digitalizada}
                        nome="Digitalização"
                        textoPosExecucao={`Digitalizada em ${prova.dataDigitalizacao}`}
                        icone={<ScannerOutlinedIcon style={{ color: prova.digitalizada ? blue[400] : grey[400] }} />}
                    />
                    
                    <Evento 
                        executado={prova.cortada}
                        nome="Corte"
                        textoPosExecucao={`Cortada em ${prova.dataCorte}`}
                        icone={<CropOutlinedIcon style={{ color: prova.cortada ? amber[800] : grey[400] }} />}
                    />

                    <Evento 
                        executado={prova.leituraMarcacoesRealizada}
                        nome="Leitura de Marcações"
                        textoPosExecucao={`Leitura de Marcações Realizada em ${prova.dataLeituraMarcacoes}`}
                        icone={<ImageSearchOutlinedIcon style={{ color: prova.leituraMarcacoesRealizada ? green[800] : grey[400] }} />}
                    />

                    <Evento 
                        executado={prova.digitacaoMarcacoesRealizada}
                        nome="Digitação de Marcações"
                        textoPosExecucao={`Digitação de Marcações Realizada em ${prova.dataDigitacaoMarcacoes}`}
                        icone={<KeyboardOutlinedIcon style={{ color: prova.digitacaoMarcacoesRealizada ? red[300] : grey[400] }} />}
                    />
                    
                    &nbsp; / &nbsp;
                </>
            }
            <span>{patternEnum(prova.status, this.state.optionsStatusProva)}</span>

            { prova.inReservaDigitacao && 
                <Tooltip 
                    title="Prova em digitação (reservada)" 
                    TransitionComponent={Zoom}
                >
                    <Chip size="small" label="Em Digitação" style={{ backgroundColor: "#0b60d0ff", fontWeight: '600', color: "white", marginLeft: '3px' }} />
                </Tooltip>
            }
          </div>
    }

    render() {
        const pageName = 'Provas';
        const links = [
            {
                path: null,
                name: 'Logística Reversa'
            }
        ];

        
        const labelNota = <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}> 
            <span style={{ paddingRight: 5 }}>
                Notas
            </span>

            <Tooltip title={`Leitura de Marcações`} TransitionComponent={Zoom}>{this.dotNota("#01378f")}</Tooltip>
            <Tooltip title={`Digitação de Marcações`} TransitionComponent={Zoom}>{this.dotNota("#d05d0b")}</Tooltip>
            <Tooltip title={`Revisão`} TransitionComponent={Zoom}>{this.dotNota("#026a12")}</Tooltip>
            <Tooltip title={`Recurso`} TransitionComponent={Zoom}>{this.dotNota("#870496")}</Tooltip>
        </div>

        const columns = [
            { label: '#', name: 'id', func: null, key: true, hidden: true },
            { label: 'Código de Prova', name: 'codigo', func: (value, id) => this.carregarCodigo(value, id), key: false, ordering: false },
            { label: 'Nome', name: 'nome', func: null, key: false },
            { label: 'CPF', name: 'cpf', func: cpfMask, key: false, ordering: false },
            { label: 'Data Recebimento', name: 'dataRecebimento', func: null, key: false, ordering: true },
            { label: 'Eventos / Status', name: 'status', func: (value, id) => this.formatarColunaStatus(id), key: false, ordering: false },
            { label: labelNota, name: 'notaCalculada', func: (value, id) => this.carregarNotas(id), key: false, ordering: false },
            { label: 'Região / Região Grupo', name: 'regiao', func: (value, id) => this.carregarRegioes(id), key: false, ordering: false },
            { label: 'Candidato', name: 'candidato', func: (value) => this.carregarNome(value),  key: false, ordering: false },
        ];

        const actions = [
            {
                name: this.labelDownloadCartao,
                func: this.handleDownloadCartao,
                icon: <GetAppIcon />,
                disabled: (id) => !isAdministradorOuCentral() || !this.state.provas.find(c => c.id === id).digitalizada,
            },
            {
                name: this.labelVerCorteMarcacoes,
                func: (id) => this.handleVerCorte(id, "bolinhas"),
                icon: <CropOutlinedIcon />,
                disabled: (id) => !isAdministradorOuCentral() || !this.state.provas.find(c => c.id === id).cortada,
            },
            {
                name: this.labelDigitarMarcacoes,
                func: this.handleDigitarMarcacoes,
                icon: <KeyboardOutlinedIcon />,
                disabled: (id) => !isAdministradorOuCentral() || this.state.provas.find(c => c.id === id).inReservaDigitacao || !this.podeDigitar(id),
            },
            {
                name: this.labelRevisarMarcacoes,
                func: this.handleRevisarMarcacoes,
                icon: <RateReviewOutlinedIcon />,
                disabled: (id) => !isAdministradorOuCentral() || this.state.provas.find(c => c.id === id).inReservaDigitacao || !this.emStatusDe(id, STATUS_REVISAO),
            },
            {
                name: this.labelVincularCandidato,
                func: this.handleVincularCandidato,
                icon: <PersonAddOutlinedIcon />,
                disabled: (id) => !isAdministradorOuCentral() || !this.provaSemVinculo(id),
            },
            {
                name: this.labelSubstituirCartao,
                func: this.handleSubstituirCartao,
                icon: <CloudUploadOutlinedIcon />,
                disabled: (id) => !this.podeSubstituirCartao(id),
            },
            {
                name: this.labelTrocarCandidatos,
                func: this.handleTrocarCandidatos,
                icon: <SwapHorizOutlinedIcon />,
                disabled: (id) => !isAdministradorOuCentral(),
            },
        ];

        const columnsCoord = [
            { label: '#', name: 'id', func: null, key: true, hidden: true },
            { label: 'Código de Prova', name: 'codigo', func: (value, id) => this.carregarCodigo(value, id), key: false },
            { label: 'Nome', name: 'nome', func: null, key: false },
            { label: 'CPF', name: 'cpf', func: cpfMask, key: false, ordering: false },
            { label: 'Data Recebimento', name: 'dataRecebimento', func: null, key: false, ordering: true },
            { label: 'Status', name: 'status', func: (value, id) => this.formatarColunaStatus(id), key: false, ordering: false },
            { label: 'Região / Região Grupo', name: 'regiao', func: (value, id) => this.carregarRegioes(id), key: false, ordering: false },
            { label: 'Candidato', name: 'candidato', func: (value) => this.carregarNome(value), key: false, ordering: false },
        ];

        const actionsCoord = [
            {
                name: this.labelDownloadCartao,
                func: this.handleDownloadCartao,
                icon: <GetAppIcon />,
                disabled: (id) => !this.state.provas.find(c => c.id === id).digitalizada,
            },
            {
                name: this.labelDigitarMarcacoes,
                func: this.handleDigitarMarcacoes,
                icon: <KeyboardOutlinedIcon />,
                disabled: (id) => this.state.provas.find(c => c.id === id).inReservaDigitacao || !this.podeDigitar(id),
            },
        ];

        this.handleFilterPersistence();

        return (
            <Layout>
                <Toast parentRef={this.setToast} />
                <Grid container >
                    <Grid item xs={12}>
                        <Breadcrumbs links={links} active={pageName} />
                    </Grid>
                </Grid>
                <Title>{pageName}</Title>

                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <ProvaFilter
                            parentRef={this.setProvaFilter}
                            handleFilterChange={this.filterData}
                        />
                                        
                        { isAdministradorOuCentral() && 
                            <ButtonAdd
                                to={{
                                    pathname: `/admin/provas/adicionar`,
                                    state: {
                                        history: {
                                            path: '/admin/provas',
                                            state: this.state,
                                        }
                                    }
                                }}
                                title="Adicionar Prova"
                            />
                        }

                        <Box marginTop={2} marginBottom={2} marginRight={3}>
                            <DownloadApps />
                        </Box>

                        <Table
                            columns={isCoordenadorOuApoioSecretarial() ? columnsCoord : columns}
                            tableData={this.state.provas}
                            actions={isCoordenadorOuApoioSecretarial() ? actionsCoord : actions}
                            groupActions={true}
                            page={this.state.page}
                            handlePage={this.handlePage}
                            handleTotalPages={this.handleTotalPages}
                            handleTotalElements={this.handleTotalElements}
                            rowsPerPage={this.state.size}
                            handleRowsPerPage={this.handleRowsPerPage}
                            sort={this.state.sort}
                            handleSort={this.handleSort}
                            handleClearSort={this.handleClearSort}
                            loading={this.state.loading}
                        />

                        { isAdministradorOuCentral() &&
                            <Box marginTop={2} textAlign="left">
                                <ButtonPrimary
                                    name="Trocar Candidatos entre Provas"
                                    startIcon={<SwapHorizOutlinedIcon />}
                                    onClick={this.handleTrocarCandidatosSemSelecao}
                                />
                            </Box>
                        }
                    </Grid>
                </Grid>

                <DialogMarcacoes
                    open={this.state.dialogMarcacoes.open}
                    idProva={this.state.dialogMarcacoes.idProva}
                    modo={this.state.dialogMarcacoes.modo}
                    onClose={this.handleCloseDialogMarcacoes}
                    onRegistered={this.handleMarcacoesRegistradas}
                />

                <DialogVincularCandidato
                    open={this.state.dialogVincularCandidato.open}
                    prova={this.state.provas.find(p => p.id === this.state.dialogVincularCandidato.idProva)}
                    onClose={this.handleCloseDialogVincularCandidato}
                    onVinculado={this.handleCandidatoVinculado}
                />

                <DialogSubstituirCartao
                    open={this.state.dialogSubstituirCartao.open}
                    prova={this.state.provas.find(p => p.id === this.state.dialogSubstituirCartao.idProva)}
                    onClose={this.handleCloseDialogSubstituirCartao}
                    onSubstituido={this.handleCartaoSubstituido}
                />

                <DialogTrocarCandidatos
                    open={this.state.dialogTrocarCandidatos.open}
                    provaInicial={this.state.provas.find(p => p.id === this.state.dialogTrocarCandidatos.idProva)}
                    onClose={this.handleCloseDialogTrocarCandidatos}
                    onTrocado={this.handleCandidatosTrocados}
                />
            </Layout>
        )
    }
}

const mapStateToProps = state => ({ contexts: state.periodos });
const mapDispatchToProps = dispatch => (bindActionCreators({ loadPeriodos }, dispatch));

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Prova));